module.exports = __webpack_public_path__ + "static/media/phone.60303bd4.svg";